import React, { Fragment } from "react"
import { Helmet } from "react-helmet"



//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import PricingTab from "../../../components/price/PricingTab"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"


const Price = () => {
    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Precios de Servicios Tecnológicos</title>
                    <meta name="description" content="Planes y precios de servicios tecnológicos de CuySoft en Ecuador. Planes básico, intermedio y avanzado para desarrollo de software, ciberseguridad y más." />
                    <meta name="keywords" content="precios servicios tecnológicos Ecuador, planes software, costos desarrollo web, precios ciberseguridad, CuySoft" />
                    <link rel="canonical" href="https://www.cuysoft.com/price" />
                    <meta property="og:title" content="Precios – CuySoft Ecuador" />
                    <meta property="og:description" content="Planes y precios accesibles para servicios tecnológicos en Ecuador." />
                    <meta property="og:url" content="https://www.cuysoft.com/price" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Precios" />
                {/* PageTitle */}

                {/*teachy-price start*/}
                <section className="cuysoft-price pt-145 pb-105 pt-lg-100 pb-lg-60">
                    <div className="container">
                        <div className="row gx-4 gx-xxl-5 align-items-center justify-content-center">
                            <div className="col-xl-5 col-lg-6 col-md-8">
                                <div className="section-title text-center mb-35">
                                    <h3 className="sect-title mb-25">Nuestros Precios Simples y Fáciles</h3>
                                    <p>Ofrecemos soluciones transparentes
                                        y entregas eficientes a través de fuentes internas u "orgánicas".</p>
                                </div>
                            </div>
                        </div>
                        {/* PricingTab */}
                        <PricingTab />
                        {/* PricingTab */}
                    </div>
                </section>
                {/*teachy-price end*/}


                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/*FooterThree start*/}
                <FooterThree />
                {/*FooterThree end*/}

            </div>

        </Fragment>
    )
}

export default Price